import { useCallback, useMemo } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { LookbooksPage } from '@/features/lookbooks/LookbooksPage';
import {
    type LookbooksSearch,
    lookbooksSearch,
    readLookbooksSearch,
    writeLookbooksSearch,
} from '@/features/lookbooks/search';

/*
  The lookbooks register. The search, the applied filters and the page ride the URL, so a
  filtered view can be shared and a reload restores it (ALS-76).
*/
export const Route = createFileRoute('/_app/lookbooks/')({
    validateSearch: (search) => lookbooksSearch.parse(search),
    component: LookbooksRoute,
});

function LookbooksRoute() {
    const raw = Route.useSearch();
    const navigate = useNavigate();
    const search = useMemo(() => readLookbooksSearch(raw), [raw]);
    const onSearchChange = useCallback(
        (next: LookbooksSearch) =>
            void navigate({
                to: '/lookbooks',
                search: writeLookbooksSearch(next),
                replace: true,
                resetScroll: false,
            }),
        [navigate],
    );
    return <LookbooksPage search={search} onSearchChange={onSearchChange} />;
}
